import { observer } from "mobx-react";

import Icon from "components/UI/IconSVG/Icon";

import "./ActionLink.scss";

const ActionLink = observer(({ action, isAnimated, isSelected, onSelect }) => {
  return (
    <div className={`action-link ${isAnimated ? "animated" : ""} ${isSelected ? "selected" : ""}`} onClick={onSelect}>
      <div className="action-link__info">
        <Icon className="action-link__icon" sprite="activities" name={action.icon} width={24} height={24} />
        <div className="action-link__text">
          <p className="action-link__text-label">{action.title}</p>
          <p className="action-link__text-sublabel">{action.titleComment}</p>
        </div>
      </div>
    </div>
  );
});

export default ActionLink;
